import { defineMessages } from 'react-intl';
/**
 * Internationalized messages for use on header.
 */
export default defineMessages({
  exploreProjects: {
    id: 'header.nav.projects',
    defaultMessage: 'Explore projects',
  },
  support: {
    id: 'header.nav.support',
    defaultMessage: 'Support',
  },
  myContributions: {
    id: 'header.nav.my_contributions',
    defaultMessage: 'My contributions',
  },
  manage: {
    id: 'header.nav.manage',
    defaultMessage: 'Manage',
  },
  logIn: {
    id: 'header.buttons.logIn',
    defaultMessage: 'Log in',
  },
  partners: {
    id: 'header.nav.partners',
    defaultMessage: 'Partners',
  },
  signUp: {
    id: 'header.buttons.signUp',
    defaultMessage: 'Sign up',
  },
  createAccount: {
    id: 'header.buttons.createAccount',
    defaultMessage: 'Create an account',
  },
  authorize: {
    id: 'header.buttons.authorize',
    defaultMessage: 'Log in',
  },
  AuthorizeTitle: {
    id: 'signUp.modal.authorize',
    defaultMessage: 'Have you finished the registration on 地图编辑器?',
  },
  AuthorizeMessage: {
    id: 'signUp.authorize.message',
    defaultMessage:
      'Start mapping now! Just login to the 分类要素样本标注系统 with your new 地图编辑器 account.',
  },
  osmRegisterCheck: {
    id: 'signUp.authorize.check',
    defaultMessage: 'Do you still need an 地图编辑器 account?',
  },
  signUpTitle: {
    id: 'signUp.modal.title',
    defaultMessage: 'Sign up',
  },
  signupLabelEmail: {
    id: 'signUp.modal.form_email',
    defaultMessage: 'Email',
  },
  signupLabelName: {
    id: 'signUp.modal.form_name',
    defaultMessage: 'Name',
  },
  proceedOSMTitle: {
    id: 'signUp.proceed_osm.osm_title',
    defaultMessage: 'Do you have an 地图编辑器 account?',
  },
  proceedOSMPart1: {
    id: 'signup.proceed_osm.text1',
    defaultMessage:
      'The 分类要素样本标注系统 works with 地图编辑器, a collaborative, open-source map of the world. Everything you map on the 分类要素样本标注系统 is going to be available on 地图编辑器.',
  },
  proceedOSMPart2: {
    id: 'signup.proceed_osm.text2',
    defaultMessage: "First, you'll need an account in order to get started.",
  },
  proceedOSMLogin: {
    id: 'signup.proceed_osm.login',
    defaultMessage: 'I already have an 地图编辑器 account',
  },
  emailPlaceholder: {
    id: 'input.placeholder.email_address',
    defaultMessage: 'Your email address',
  },
  invalidEmail: {
    id: 'input.errors.email_address',
    defaultMessage: 'Invalid email address',
  },
  invalidName: {
    id: 'input.errors.name',
    defaultMessage: 'Invalid name',
  },
  namePlaceHolder: {
    id: 'input.placeholder.Name',
    defaultMessage: 'Your Name',
  },
  settings: {
    id: 'header.nav.settings',
    defaultMessage: 'Settings',
  },
  myTeams: {
    id: 'header.nav.my_teams',
    defaultMessage: 'My teams',
  },
  logout: {
    id: 'header.nav.logout',
    defaultMessage: 'Logout',
  },
  email: {
    id: 'signup.modal.email',
    defaultMessage: 'Email',
  },
  submitProceed: {
    id: 'signup.button.submit',
    defaultMessage: 'Next',
  },
  submitProceedOSM: {
    id: 'signup.button.submit_osm',
    defaultMessage: 'Create 地图编辑器 account',
  },
  signUpQuestion: {
    id: 'signup.modal.question',
    defaultMessage: 'Please provide your name and email address:',
  },
  emailUpdateButton: {
    id: 'emailUpdate.modal.button',
    defaultMessage: 'Update',
  },
  emailUpdateSuccess: {
    id: 'emailUpdate.modal.success_message',
    defaultMessage: 'Email updated successfully',
  },
  emailUpdateTitle: {
    id: 'emailUpdate.modal.title',
    defaultMessage: 'Update your email',
  },
  emailUpdateTextPart1: {
    id: 'emailUpdate.modal.text1',
    defaultMessage: 'Before you begin mapping, please add your email address.',
  },
  emailUpdateTextPart2: {
    id: 'emailUpdate.modal.text2',
    defaultMessage:
      'We are mapping together! Providing your email address is necessary for mapping feedback and direct messages to reach you.',
  },
  privacyPolicy: {
    id: 'emailUpdate.modal.privacy_policy',
    defaultMessage:
      "Read our Privacy Policy for more information on how we protect users' personal data.",
  },
  newVersionAvailable: {
    id: 'serviceWorker.dialog.newVersion',
    defaultMessage: '分类要素样本标注系统 has been updated.',
  },
  newVersionAvailableLineTwo: {
    id: 'serviceWorker.dialog.newVersionAvailableLineTwo',
    defaultMessage: 'Click the button to refresh and ensure the page is displayed correctly.',
  },
  update: {
    id: 'serviceWorker.dialog.update',
    defaultMessage: 'Refresh',
  },
  remindMeLater: {
    id: 'serviceWorker.dialog.remindMeLater',
    defaultMessage: 'Remind me later',
  },
});
